import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28758f26"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "border-bottom pb20" }
const _hoisted_2 = { class: "ris-wrapper" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ris-content" }, [
  /*#__PURE__*/_createElementVNode("p", null, "1、税务信息变更操作路径：我要办税-综合信息报告-身份信息报告-一照一码信息变更"),
  /*#__PURE__*/_createElementVNode("p", null, "2、跨区迁移操作路径：套餐业务-跨区迁移")
], -1))
const _hoisted_5 = { class: "help-file-wrapper" }

import { FileType } from "@/types/procss";
import HeadTitle from "@/components/HeadTitle.vue";
import HelpFile from "@/components/HelpFile.vue";
import Image from "@/components/Image.vue";
import {
  ref,
  withDefaults,
  reactive,
} from "vue";
import { 
  taxAddressApplyApi,//印章证照刻制提交
  taxAddressDetailApi,//印章证照刻制申请
 } from "@/api/businessChange";
import change from "@/composables/change"
import { NodeItem } from "@/types/procss";

export default /*#__PURE__*/_defineComponent({
  props: {
    BranchCompanyFlowId: { default: 0 },
    preData: { default: () => [] },
    reEdit: { type: Boolean, default: false },
    update: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { BranchCompanyFlowId: number, preData:NodeItem[], reEdit:boolean, update: boolean }


const fileList: { title: string; type: FileType; link: string}[] = [
  {
    title: "流程一图示",
    type: FileType.PNG,
    link: "TaxAddress1",
  },{
    title: "流程二图示",
    type: FileType.PNG,
    link: "TaxAddress2",
  },
];
// 表单字段定义
const FormData = reactive({
  PageFiles:[],
});
const IsQYTZSEdit = ref<boolean>(false); //纳税人迁移是否可编辑 true可编辑
const IsSWDJEdit = ref<boolean>(false); //税务登记是否可编辑


const IsFirstNSRQYEdit = ref<boolean>(false); //是否第一次上传纳税人迁移
const IsFirstSWDJEdit = ref<boolean>(false); //是否第一次上传税务登记
//上传附件
const handleUpload = (file: File, index?: number) => {
  
  if (!file) {
    FormData.PageFiles[index as number] = {};
  } else {
    if(!FormData.PageFiles[index] || !FormData.PageFiles[index].FileUrl){
      if(index == 0){//判断审批页面是否有删除标识
        IsFirstNSRQYEdit.value = true; //是否第一次提交
      }else if(index == 1){
        IsFirstSWDJEdit.value = true; //是否第一次提交
      }
    }
    let _file = Object.assign({}, file, { FileUrl: file.Url });
    FormData.PageFiles[index as number] = _file;
  }
};

//封装方法字段
const FormRef = ref()
const common = reactive({
  ApplyApi:taxAddressApplyApi,
  DetailApi:taxAddressDetailApi,
  FormData:FormData,
  nodeIdx:7,
  FormRef:FormRef,
  props:reactive(props),
  IsFirstEdit1:IsFirstNSRQYEdit,
  IsFirstEdit2:IsFirstSWDJEdit,
  IsQYTZSEdit:IsQYTZSEdit,
  IsSWDJEdit:IsSWDJEdit,
})

const {
  edit,
  actionButtons,
} = change(common)

//设置页面动态高度
const winHeight = ref(0)
const setWinHeight = () => {
  winHeight.value = document.querySelector('.side-box').getBoundingClientRect().height  - 304;
}
setWinHeight()

return (_ctx: any,_cache: any) => {
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(HeadTitle, { title: "申请流程" }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: require('@/assets/imgs/Book/attention.png')
        }, null, 8, _hoisted_3),
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(fileList, (item, index) => {
          return _createVNode(HelpFile, {
            key: index,
            title: item.title,
            "file-path": item.link,
            "file-type": item.type,
            noDownload: true
          }, null, 8, ["title", "file-path", "file-type"])
        }), 64))
      ])
    ]),
    _createVNode(HeadTitle, {
      title: "上传文件",
      class: "mt20"
    }),
    _createVNode(_component_a_form, {
      class: _normalizeClass(["bussiness-form-wrapper", !_unref(edit)? 'border-bottom mb24': '']),
      layout: "vertical",
      validateTrigger: "blur",
      model: _unref(FormData),
      ref_key: "FormRef",
      ref: FormRef
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, {
          name: ['PageFiles', 0, 'FileUrl'],
          label: "纳税人迁移通知书"
        }, {
          default: _withCtx(() => [
            _createVNode(Image, {
              value:  _unref(FormData).PageFiles[0] && _unref(FormData).PageFiles[0]?.FileUrl,
              "disable-close": !( IsFirstNSRQYEdit.value || (IsQYTZSEdit.value && _unref(edit))),
              disable: !!__props.preData || !(_unref(edit) || _unref(actionButtons).includes('-3')),
              onUpload: _cache[0] || (_cache[0] = (file) => handleUpload(file, 0)),
              "file-type": '1311'
            }, null, 8, ["value", "disable-close", "disable"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          name: ['PageFiles', 1, 'FileUrl'],
          label: "《税务登记(跨区、区内)迁移申请审批表》"
        }, {
          default: _withCtx(() => [
            _createVNode(Image, {
              value:  _unref(FormData).PageFiles[1] && _unref(FormData).PageFiles[1]?.FileUrl,
              "disable-close": !(IsFirstSWDJEdit.value || (IsSWDJEdit.value && _unref(edit))),
              disable: !!__props.preData || !(_unref(edit) || _unref(actionButtons).includes('-3')),
              onUpload: _cache[1] || (_cache[1] = (file) => handleUpload(file, 1)),
              "file-type": '1312'
            }, null, 8, ["value", "disable-close", "disable"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["class", "model"])
  ], 64))
}
}

})